import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { ControlSheetNoteDTO } from '@/types/controlsheet'
import { useNotification } from '@/ui/Notification'

interface ICreateAnnotationNoteRequest {
    note: string
    annotationId: string
}

export const useCreateAnnotationNote = () => {
    const { showNotification } = useNotification()

    const createAnnotationNoteMutation = useAppMutation<ControlSheetNoteDTO, Error, ICreateAnnotationNoteRequest>({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/${data.annotationId}/note`,
                method: 'POST',
                data: { note: data.note }, // Only send note in the body
            }),
        alertOnError: true,
        onSuccess: async () => {
            showNotification({ message: 'Note added successfully' })
        },
    })

    const handleCreateAnnotationNoteAsync = async (note: string, annotationId: string) =>
        await createAnnotationNoteMutation.mutateAsync({
            note,
            annotationId: annotationId,
        })

    return {
        handleCreateAnnotationNoteAsync,
        isPending: createAnnotationNoteMutation.isPending,
        data: createAnnotationNoteMutation.data,
    }
}
